import React, { useContext, useEffect, useState } from 'react'
import PointTracker from './PointTracker'
import { Modal } from 'react-bootstrap';
import { callAPI } from '../helper/apiHelper';
import { API_URL_ENDPOINT, BASE_URL } from '../appsetting/appsetting';
import CButton from './CButton';
import { SocketContext, UserContext } from '../context/UserContext';
import { Avatar } from '@mui/material';

const Header = ({room, liveMembers, getLivemember}) => {
    const [totalParticipate, setTotalParticipate] = useState(0);
    const [showParticipate, setShowParticipate] = useState(false)
    const [btnload, setbuttonload] = useState(false)
    const { globalUser } = useContext(UserContext);
    const [membersWithStatus, setMembersWithStatus] = useState([])
  

    const [timeElapsed, setTimeElapsed] = useState({ hours: 0, minutes: 0, seconds: 0 });

    const { socket } = useContext(SocketContext)

    useEffect(() => {
      if(!room?.StartedAt) return;

      const startTime = room?.StartedAt ? new Date(room?.StartedAt) : new Date();
      const updateTimer = () => {
        const now = new Date();
        const diffInMilliseconds = now - startTime;
        const totalSeconds = Math.floor(diffInMilliseconds / 1000);
        
        const hours = Math.floor(totalSeconds / 3600); // 3600 seconds in an hour
        const minutes = Math.floor((totalSeconds % 3600) / 60); // remaining minutes
        const seconds = totalSeconds % 60; // remaining seconds
      
        const paddedHours = String(hours).padStart(2, "0");
        const paddedMinutes = String(minutes).padStart(2, "0");
        const paddedSeconds = String(seconds).padStart(2, "0");

        setTimeElapsed({ hours: paddedHours, minutes: paddedMinutes, seconds: paddedSeconds });
      };
  
      // Initial calculation
      updateTimer();
  
      // Update timer every second
      const interval = setInterval(updateTimer, 1000);
  
      // Cleanup interval on component unmount
      return () => clearInterval(interval);
    }, [room]);


    useEffect(()=>{
      if (!socket) return;
      socket.on('user-connected', handleNewUserJoined);
  
      return () => {
        socket.off('user-connected')
      }
    },[socket])


    const handleNewUserJoined = (userID) => {
      const user = liveMembers.find(user => user.UserID === userID);
      if(!user){
        getLivemember(room?.RoomID);
      }
    }

    const handleShowParticipate = async () => {
      try{
        setbuttonload(true)
        if(globalUser?.isHost){
          await fetchMemberWithStatus(room?.RoomID)
        }
        setShowParticipate(true)
      }catch(error){
        setShowParticipate(false)
      }finally{
        setbuttonload(false)
      }
    }

    const fetchMemberWithStatus = async (rid = null) =>{
      try{
        const response = await callAPI(`${BASE_URL}${API_URL_ENDPOINT.GET_LIVE_MEMBERS}?roomID=${rid ?? room?.RoomID}&withStatus=true`);
        if(response?.status){
          if(response?.data?.length>0){
            setMembersWithStatus(response.data)
          }
        }else{
          throw new Error(response?.message || "No Request Found")
        }
      }catch(error){
        setMembersWithStatus([])
      }
    }

    const handleShare = () => {
      // Dynamic referral code (replace with actual user data)
      const referralCode = globalUser?.ReferralCode; 
      const appLink = `https://jsvsapp.in/referral?code=${referralCode}`;
    
      // Shareable message
      const shareMessage = `🙏 जाम्भाणी जीवन दर्शन में आपका स्वागत है!  
                            अगर आप मेरा *Referral Code* ${referralCode} इस्तेमाल करते हैं, तो आप हमारे साथ जुड़ सकते हैं।  
                            अभी *LIVE* चल रहा है — जुड़ें और भजनों का आनंद लें!  
                            अभी रजिस्टर करें: ${appLink}`;

    
      // Check if Web Share API is available
      if (navigator.share) {
        navigator.share({
          title: "जाम्भाणी जीवन दर्शन Referral",
          text: shareMessage,
          url: appLink, // This allows users to share links
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Sharing failed", error));
      } else {
        // Fallback to WhatsApp
        const encodedMessage = encodeURIComponent(shareMessage);
        const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
        window.open(whatsappUrl, "_blank");
      }
    };
    

  return (
    <div className='border my-2 p-1 rounded card'>
        {/* {console.log('Header')} */}
        <div className='d-flex justify-content-between align-items-center'>
          <div className='d-flex align-items-center'>
            <img className='bg-white rounded-circle' src='/asset/text1.png' style={{width:40, height:40, border:'1px solid #FF3601'}} />
            <div className='text-start ps-2'>
              {/* <img className='bg-white p-1 ms-2' src='/asset/text.png' style={{ height:30}} /> */}
              <h6 className='mb-1 fw-bold' style={{color:'#FF3601'}}>जाम्भाणी जीवन दर्शन</h6>
              <h6 className='mb-0 fw-bold' style={{fontSize:10}}></h6>
            </div>
          </div>
          <div className='text-start'>
            <CButton onClick={handleShare}>
              <span style={{color:'#25D366'}}>
                <i className="bi bi-whatsapp"></i>
              </span>
            </CButton>
            <CButton onClick={handleShowParticipate} isLoading={btnload}>
              <span style={{color:'#FF3601'}}>
                <i className="bi bi-people-fill"></i> {liveMembers.length ?? 0} 
              </span>
            </CButton>
          </div>
          {/* <div style={{fontSize:12}} className=' fw-bold text-warning'>Point Win : 0</div> */}
        </div>

        <div className='d-flex mt-1 border rounded-1 fw-bold'>
          <div className='rounded-1 text-white px-2 align-items-center d-flex' style={{fontSize: 10, whiteSpace: 'nowrap', background:'#FF3601'}}>
          {timeElapsed.hours > 0 && `${timeElapsed.hours} : `} {timeElapsed.minutes} : {timeElapsed.seconds} <span className='px-1'>•</span> <PointTracker/>
          </div>
          <marquee className='d-inline mx-2' style={{color:'#FF3601'}}>{room?.LiveTitle ?? "No Title"}</marquee>
        </div>


        <Modal show={showParticipate} onHide={()=>setShowParticipate(false)}>
        <Modal.Header closeButton>
          <Modal.Title><div className='d-flex flex-column'>Live Members <span style={{fontSize:12}}>Total Members : {liveMembers.length ?? 0}</span></div></Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-2 overflow-auto' style={{height:'75vh'}}>
          
          {globalUser?.isHost ? (
            membersWithStatus.map((row, index)=>(
              <div className='py-1 px-2 border-bottom' key={index}>
                <div className='d-flex justify-content-start align-items-center'>
                    <div className='me-2'>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <Avatar sx={{ width: 30, height: 30 }} alt={row?.FullName} src={(row?.ProfilePhoto) && `data:image/jpeg;base64,${row?.ProfilePhoto}`} />
                        {row?.isActive && (
                          <span
                          style={{
                            position: 'absolute',
                            bottom: -3,
                            right: -3,
                            width: 13,
                            height: 13,
                            backgroundColor: 'green',
                            borderRadius: '50%',
                            border: '2px solid white',
                          }}
                          />
                        )}
                      </div>
                    </div>
                    <div>
                      <div className='text-dark' style={{fontSize:14}}>{row.FullName}</div>
                      <div className='text-dark' style={{fontSize:10}}>{row?.City}, {row?.State}</div>
                    </div>
                </div>
              </div>
            ))
          ) : (
            liveMembers.map((row, index)=>(
              <div className='py-1 px-2 border-bottom' key={index}>
                <div className='d-flex justify-content-start align-items-center'>
                    <div className='me-2'>
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <Avatar sx={{ width: 30, height: 30 }} alt={row?.FullName} src={(row?.ProfilePhoto) && `data:image/jpeg;base64,${row?.ProfilePhoto}`} />
                      </div>
                    </div>
                    <div>
                      <div className='text-dark' style={{fontSize:14}}>{row.FullName}</div>
                      <div className='text-dark' style={{fontSize:10}}>{row?.City}, {row?.State}</div>
                    </div>
                </div>
              </div>
            ))
          )}

        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Header